module.exports = __webpack_public_path__ + "img/drop.d96413ee.svg";